import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
export const Greeting = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 10
    }} transition={{
      delay: 0.5
    }} className="text-2xl font-semibold">Hello there!</motion.div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div key="overview" className="max-w-xl mx-auto md:mt-20 px-8 size-full flex flex-col text-center justify-center">{t0}<motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 10
      }} transition={{
        delay: 0.6
      }} className="text-2xl text-zinc-500">Let's start your journey!</motion.div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};